var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _vm.template
        ? _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c(
                "w-card",
                [
                  _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("reminders")))]),
                  _c(
                    "w-card-content",
                    [
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { xl: "12" } },
                            [
                              _c("app-custom-language-select", {
                                attrs: {
                                  fancy: "",
                                  label: _vm.$t("common.lang"),
                                },
                                model: {
                                  value: _vm.lang,
                                  callback: function ($$v) {
                                    _vm.lang = $$v
                                  },
                                  expression: "lang",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { sm: "12" } },
                            [
                              _c("w-select", {
                                attrs: {
                                  label: _vm.$ct("reminder-template-label"),
                                  items: _vm.reminderTemplates,
                                  fancy: "",
                                },
                                model: {
                                  value: _vm.reminder,
                                  callback: function ($$v) {
                                    _vm.reminder = $$v
                                  },
                                  expression: "reminder",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { sm: "12" } },
                            [
                              _c("w-input", {
                                attrs: { label: _vm.$ct("title"), fancy: "" },
                                model: {
                                  value:
                                    _vm.template.Title.Translations[_vm.lang],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.template.Title.Translations,
                                      _vm.lang,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "template.Title.Translations[lang]",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { sm: "12" } },
                            [
                              _c("w-textarea", {
                                style: { width: "100%", minHeight: "400px;" },
                                attrs: {
                                  height: "250",
                                  fancy: "",
                                  label: _vm.$ct("text"),
                                },
                                model: {
                                  value:
                                    _vm.template.Content.Translations[_vm.lang],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.template.Content.Translations,
                                      _vm.lang,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "template.Content.Translations[lang]",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { sm: "12" } },
                            [
                              _c("w-input", {
                                attrs: {
                                  label: _vm.$ct("signature"),
                                  fancy: "",
                                },
                                model: {
                                  value:
                                    _vm.template.Signature.Translations[
                                      _vm.lang
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.template.Signature.Translations,
                                      _vm.lang,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "template.Signature.Translations[lang]",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            [
                              _c(
                                "w-link",
                                {
                                  staticClass: "mt",
                                  on: {
                                    click: function ($event) {
                                      return _vm.restoreTemplates()
                                    },
                                  },
                                },
                                [
                                  _c("w-fa", { attrs: { icon: "tools" } }),
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$ct(
                                          "restore-email-templates-button"
                                        )
                                      ) +
                                      " "
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.$wf.isLgUp
        ? _c(
            "w-col",
            { attrs: { xs: "6" } },
            [
              _c(
                "w-card",
                [
                  _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("layouts")))]),
                  _c(
                    "w-list",
                    [
                      _vm._l(_vm.layouts, function (layout) {
                        return _c(
                          "w-list-item",
                          { key: layout.ID },
                          [
                            _c("w-list-item-text", [
                              _vm._v(_vm._s(layout.Name)),
                            ]),
                            _vm.isElectron
                              ? _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: _vm.$ct(
                                              "set-default-printer"
                                            ),
                                            expression:
                                              "$ct('set-default-printer')",
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.editElectronProperties(
                                              layout
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("w-fa", {
                                          attrs: { icon: "print" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "w-list-item-action",
                              [
                                _c(
                                  "w-button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: _vm.$ct("common.edit"),
                                        expression: "$ct('common.edit')",
                                      },
                                    ],
                                    attrs: {
                                      to:
                                        "/settings/reminder-layout/" +
                                        layout.ID,
                                    },
                                  },
                                  [_c("w-fa", { attrs: { icon: "pen" } })],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "w-list-item-action",
                              [
                                _c(
                                  "w-button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: _vm.$ct("common.delete"),
                                        expression: "$ct('common.delete')",
                                      },
                                    ],
                                    staticClass: "danger",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteLayout(layout)
                                      },
                                    },
                                  },
                                  [_c("w-fa", { attrs: { icon: "trash" } })],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      _c(
                        "w-list-item",
                        { attrs: { to: "/settings/reminder-layout/new" } },
                        [
                          _c("w-list-item-text", [
                            _c(
                              "span",
                              [
                                _c("w-fa", { attrs: { icon: "plus" } }),
                                _vm._v(
                                  " " + _vm._s(_vm.$t("common.add")) + " "
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                  _c(
                    "w-modal",
                    {
                      attrs: { value: _vm.editElectronPropertiesLayoutId > 0 },
                    },
                    [
                      _vm.editElectronPropertiesLayoutId
                        ? _c(
                            "app-reminder-documents-layout-edit-electron-properties",
                            {
                              attrs: {
                                "layout-id": _vm.editElectronPropertiesLayoutId,
                                printers: _vm.printers,
                              },
                              on: {
                                close: function ($event) {
                                  _vm.editElectronPropertiesLayoutId = 0
                                },
                              },
                            }
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }